import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';
const EscortAgencyTable=React.lazy(()=>import('./EscortAgencyTable'));

export const EscortAgencysConfigs = [
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/onboard-corporate/escort-agency/list',
    element: <EscortAgencyTable/>,
  },
 

];
